/* =========================================================
   WWC Manual City Bubbles
   Requires Swiper loaded globally in theme.liquid
========================================================= */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-wwc-manual-bubbles]';

  function toBool(value) {
    return value === true || value === 'true' || value === '1';
  }

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function waitForSwiper(callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        callback();
      }

      if (tries > 80) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  function getInitialIndex(root, slides) {
    var startIndex = toNumber(root.dataset.startIndex, 0);
    var startOnActive = toBool(root.dataset.startOnActive);

    if (startOnActive) {
      var activeIndex = slides.findIndex(function (slide) {
        return slide.dataset.active === '1';
      });

      if (activeIndex >= 0) {
        startIndex = activeIndex;
      }
    }

    if (startIndex < 0 || startIndex >= slides.length) {
      startIndex = 0;
    }

    return startIndex;
  }

  function initBubbles(root) {
    if (!root || root.dataset.wwcBubblesReady === '1') return;

    root.dataset.wwcBubblesReady = '1';

    var slider = root.querySelector('[data-wwc-bubbles-slider]');
    var track = root.querySelector('[data-wwc-bubbles-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.swiper-slide'));

    if (!slider || !track || !slides.length) return;

    var showNav = toBool(root.dataset.showNav);
    var showScrollbar = toBool(root.dataset.showScrollbar);
    var mobileSingleCard = toBool(root.dataset.mobileSingleCard);
    var greyUnreachable = toBool(root.dataset.greyUnreachable);
    var hideNavWhenUnneeded = toBool(root.dataset.hideNavWhenUnneeded);

    var buttonsWrap = root.querySelector('[data-wwc-bubbles-buttons]');
    var btnPrev = root.querySelector('.wwc-bubbles__button--prev');
    var btnNext = root.querySelector('.wwc-bubbles__button--next');
    var scrollbar = root.querySelector('[data-wwc-bubbles-scrollbar]');

    var mediaMobile = window.matchMedia('(max-width: 749px)');
    var isMobile = mediaMobile.matches;
    var oneCardMobile = mobileSingleCard && isMobile;
    var initialIndex = getInitialIndex(root, slides);

    function fitsCompletely() {
      return track.scrollWidth <= slider.clientWidth + 1;
    }

    function setDisabled(button, state) {
      if (!button) return;

      button.classList.toggle('is-disabled', state && greyUnreachable);
      button.setAttribute('aria-disabled', state ? 'true' : 'false');
    }

    function updateNavState(swiper) {
      if (!showNav || !btnPrev || !btnNext || !buttonsWrap) return;

      var noScroll = fitsCompletely();

      if (hideNavWhenUnneeded) {
        buttonsWrap.style.display = noScroll ? 'none' : '';
      }

      if (noScroll) {
        setDisabled(btnPrev, true);
        setDisabled(btnNext, true);
        return;
      }

      setDisabled(btnPrev, swiper.isBeginning);
      setDisabled(btnNext, swiper.isEnd);
    }

    waitForSwiper(function () {
      var swiper = new window.Swiper(slider, {
        speed: 300,
        initialSlide: initialIndex,
        slidesPerView: oneCardMobile ? 1 : 'auto',
        centeredSlides: oneCardMobile,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        navigation: showNav && btnNext && btnPrev ? {
          nextEl: btnNext,
          prevEl: btnPrev
        } : false,
        scrollbar: showScrollbar && scrollbar ? {
          el: scrollbar,
          draggable: true
        } : false
      });

      track.classList.add('is-ready');
      slider.setAttribute('aria-busy', 'false');

      function refresh() {
        swiper.update();
        updateNavState(swiper);
      }

      window.requestAnimationFrame(function () {
        swiper.slideTo(initialIndex, 0, false);
        refresh();
      });

      swiper.on('slideChange', function () {
        updateNavState(swiper);
      });

      swiper.on('resize', refresh);
      swiper.on('observerUpdate', refresh);

      window.addEventListener('resize', refresh, { passive: true });

      var images = root.querySelectorAll('img');
      images.forEach(function (image) {
        if (image.complete) return;
        image.addEventListener('load', refresh, { once: true });
        image.addEventListener('error', refresh, { once: true });
      });

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (event) {
          if (event.target && event.target.contains(root)) {
            refresh();
          }
        });
      }
    });
  }

  function initAllBubbles() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initBubbles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBubbles);
  } else {
    initAllBubbles();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;

    var roots = event.target.matches && event.target.matches(ROOT_SELECTOR)
      ? [event.target]
      : Array.prototype.slice.call(event.target.querySelectorAll(ROOT_SELECTOR));

    roots.forEach(initBubbles);
  });
})();